import React, { useReducer, useEffect } from 'react';
import {
	getAuth,
	signInWithEmailAndPassword,
	sendPasswordResetEmail,
} from 'firebase/auth';
import AuthContext from './AuthContext';
import AuthReducer from './AuthReducer';

export default function AuthState({ children }) {
	const initialState = {
		isAuth: '',
		currentUser: '',
	};
	const [state, dispatch] = useReducer(AuthReducer, initialState);
	const { isAuth, currentUser } = state;
	const auth = getAuth();

	const handleLogin = (values, props) => {
		if (values && props) {
			const { email, pwd } = values;
			const { setSubmitting, setStatus } = props;

			signInWithEmailAndPassword(auth, email, pwd)
				.then((userCredential) => {
					setSubmitting(true);
					dispatch({
						type: 'SET_USER_AUTH',
						payload: userCredential,
					});

					localStorage.setItem('user', JSON.stringify(userCredential.user));
				})
				.catch((error) => {
					dispatch({
						type: 'SET_USER_AUTH',
						payload: '',
					});
					setSubmitting(false);
					setStatus({ error: `${error.code}` });
					setTimeout(() => {
						setStatus('');
					}, 3000);
				});
		}
	};

	const resetPassword = async (values, props) => {
		if (values && props) {
			const { email } = values;
			const { setSubmitting, setStatus } = props;

			try {
				await sendPasswordResetEmail(auth, email);
				console.log(
					'Correo electrónico para restablecer la contraseña enviado exitosamente.'
				);
				setSubmitting(false);
				setStatus({
					success: `Correo electrónico para restablecer la contraseña enviado exitosamente a ${email}.`,
				});
			} catch (error) {
				console.error(
					'Error al enviar el correo electrónico para restablecer la contraseña:',
					error
				);
				setSubmitting(false);
				setStatus({ error: `${error.code}` });
				setTimeout(() => {
					setStatus('');
				}, 3000);
			}
		}
	};

	useEffect(() => {
		handleLogin();
	}, []);

	return (
		<AuthContext.Provider
			value={{ isAuth, currentUser, handleLogin, resetPassword }}
		>
			{children}
		</AuthContext.Provider>
	);
}
